import React, {Component} from 'react'
import {connect} from 'react-redux'
import CopyURLSegment from "../../SharedComponents/CopyURLSegment";
import styles from "../../SQL/styles";
import AceEditor from 'react-ace';
import 'brace/theme/monokai';
import 'brace/mode/json';
import getURLParam from "../../Constants/getURLParam";
import {getQueryParamValue} from "../../Constants/getQueryParamValue";
import BannerAlert from "../../SharedComponents/BannerAlert";
import {isMobile} from "react-device-detect";
import { Button } from 'semantic-ui-react'
import {toggleToast} from "../../Actions/ToggleToast";
import API_Backend_Root from "../../Constants/API_Backend_Root";
import {toggleModal} from "../../Actions/ToggleModal";
import {Dropdown} from "semantic-ui-react";
import { Menu } from 'semantic-ui-react'
import Icons from "../../Constants/Icons";
import ReactJson from 'react-json-view'

import CustomAccordion from "../../SharedComponents/CustomAccordion";
import JSONOutputPreview from "../JSONOutputPreview";
import CodeSnippet from "../CodeSnippet";

class MacroIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            receiveInfo: false,
            executeType: 'formulas',
            displayType: 'documentation'
        }

        this.handleFormatChange = this.handleFormatChange.bind(this);
    }

    handleFormatChange(event, {value}){
        this.setState({
            executeType: value
        })
    }

    componentDidMount(){
        fetch(API_Backend_Root + "store-analytics-from-ui/", {
            method: "POST",
            body: JSON.stringify({"data": {"Email":localStorage.getItem("email"),
                    "Notes":"User clicked on Excel Macro tab","Use Case":"Excel Macros","Date Saved":(new Date()).toLocaleDateString(),"Usage Metrics":""},
                "headers": {"accessKey": "2863a49b9ea04e9847cb90f0e0aa93d5", "secretKey": "9eca419e34ff1e929f05d00598dfb679"},
                "apiUrl": "https://api.apispreadsheets.com/data/Zh4Ob0LXhmZN3goL/", "sendEmailAlert": false}),
        }).then(res =>{
            if (res.status === 201){
                console.log("lead saved")
            }
            else{
                console.log("lead not saved")
            }
        }).catch(err => console.log(err))
    }

    receiveInformation = () => {
        // this.setState({
        //     receiveInfo: true
        // })

        // const finalMessage = () => {
        //     this.setState({
        //         receiveInfo: false
        //     }, () => this.props.toggleToast({show: true, message: "Thank you for your interest. We will be reaching out with next steps shortly!", type: "success"}))
        // }

        this.props.toggleModal("runMacrosReceiveInformationalModal")

        fetch(API_Backend_Root + "store-analytics-from-ui/", {
            method: "POST",
            body: JSON.stringify({"data": {"Email":localStorage.getItem("email"),
                    "Notes":"User clicked Receive Information button on Excel Macro tab","Use Case":"Excel Macros","Date Saved":(new Date()).toLocaleDateString(),"Usage Metrics":""},
                "headers": {"accessKey":"2863a49b9ea04e9847cb90f0e0aa93d5", "secretKey":"9eca419e34ff1e929f05d00598dfb679"},
                "apiUrl": "https://api.apispreadsheets.com/data/Zh4Ob0LXhmZN3goL/", "sendEmailAlert": true})
        }).then(res =>{
            // finalMessage()
        }).catch(err => {
            console.log(err)
        })
    }

    generateCurlCommand = (jsonparams, url) => {
        // Parse the JSON parameters
        let params = JSON.parse(jsonparams);

        // Construct the cURL command
        let curlCommand = `curl -X POST ${url}\n-H "Content-Type: application/json"\n-d '${JSON.stringify(params)}'`;

        return curlCommand;
    }

    handleActionTypeChange = (e, { name }) => {
        this.setState({ displayType: name })
    }

    getSamplePayload = () => {
        try {
          const pkFileInfo = this.props.fileInformation[this.props.pkID];
      
          // Detect filename-like values (e.g., ends with .csv/.xlsx)
          const looksLikeFilename = (n) => /\.[A-Za-z0-9]+$/.test(n || "");
      
          // Prefer the actively selected sheet from Redux
          const selectedSheet = this.props.sheetRead ? this.props.sheetRead[this.props.pkID] : undefined;
      
          let sheetName = "Sheet 1";
          if (selectedSheet && !looksLikeFilename(selectedSheet)) {
            sheetName = selectedSheet;
          } else if (pkFileInfo && pkFileInfo.sheetRead && !looksLikeFilename(pkFileInfo.sheetRead)) {
            sheetName = pkFileInfo.sheetRead;
          } else if (pkFileInfo && pkFileInfo.sheetNames && pkFileInfo.sheetNames.length > 0) {
            var firstNonFilename = pkFileInfo.sheetNames.find(function(n){ return !looksLikeFilename(n); });
            if (firstNonFilename) { sheetName = firstNonFilename; }
          }
      
          // Pull a couple of sample values if available; otherwise use placeholders
          const sampleData = pkFileInfo ? pkFileInfo["jsonColumnSample"] : null;
          let a1Val = "01-02-2025";
          let a2Val = "new input value 2";
      
          try {
            const keys = Object.keys(sampleData);
            const v1 = sampleData[keys[0]][0];
            if (v1 !== undefined && v1 !== null) { a1Val = v1; }
          } catch (e) {}
      
          try {
            const keys = Object.keys(sampleData);
            const v2 = sampleData[keys[0]][1];
            if (v2 !== undefined && v2 !== null) { a2Val = v2; }
          } catch (e) {}
      
          return {
            post_formula_actions: [{ type: "macro", parameters: { name: "macro_name" } }],
            macros: "macro_name",
            input_cells: { [sheetName]: { "A1": "4508", "A2": "01-02-2025" } },
            output_cells: { [sheetName]: ["F31", "H50", "H51", "F84", "F86"] }
          };
        } catch (e) {
          return {
            post_formula_actions: [{ type: "macro", parameters: { name: "macro_name" } }],
            macros: "macro_name",
            input_cells: { "Sheet 1": { "A1": "new input value", "A2": "new input value 2" } },
            output_cells: { "Sheet 1": ["F31", "H50", "H51", "F84", "F86"] }
          };
        }
      }

    getCodeSamples = () => {
        const url = this.props.getURL.replace("/data/", "/macro/");
        const samplePayload = this.getSamplePayload();
        
        // Get access key and secret key from URL if present
        let accessKey = getQueryParamValue("accessKey", url);
        let secretKey = getQueryParamValue("secretKey", url);
        
        let jsonPayload;
        if (this.state.executeType === "macros") {
            jsonPayload = {
                "post_formula_actions": [{"type": "macro", "parameters": {"name": "GetPremium"}}],
                "macros": "GetPremium",
                "macro_parameters": ["Male", 30],
                "sheet_name": "Rates",
                "output_cells": ["C8", "C9"],
                "save_file_post_call": true
            };
        } else {
            jsonPayload = {
                "post_formula_actions": [{"type": "macro", "parameters": {"name": "macro_name"}}],
                "macros": "macro_name",
                "input_cells": samplePayload.input_cells,
                "output_cells": samplePayload.output_cells,
                "save_file_post_call": true
            };
        }

        const cleanUrl = url.includes("?") ? url.substring(0, url.indexOf("?")) : url;

        return {
            cURL: this.getCURLCode(cleanUrl, jsonPayload, accessKey, secretKey),
            python: this.getPythonCode(cleanUrl, jsonPayload, accessKey, secretKey),
            javascript: this.getJavascriptCode(cleanUrl, jsonPayload, accessKey, secretKey),
            ruby: this.getRubyCode(cleanUrl, jsonPayload, accessKey, secretKey),
            PHP: this.getPHPCode(cleanUrl, jsonPayload, accessKey, secretKey)
        };
    }

    getCURLCode = (url, payload, accessKey, secretKey) => {
        let headers = '-H "Content-Type: application/json"';
        if (accessKey) {
            headers += ` \\\n-H "accessKey: ${accessKey}"`;
        }
        if (secretKey) {
            headers += ` \\\n-H "secretKey: ${secretKey}"`;
        }
        
        return `curl -X POST '${url}' \\
${headers} \\
-d '${JSON.stringify(payload)}'`;
    }

    getPythonCode = (url, payload, accessKey, secretKey) => {
        let headers = {
            "Content-Type": "application/json"
        };
        
        if (accessKey) {
            headers["accessKey"] = accessKey;
        }
        if (secretKey) {
            headers["secretKey"] = secretKey;
        }

        return `# pip install requests

import requests
import json

url = "${url}"
payload = ${JSON.stringify(payload, null, 4).replace(/\n/g, '\n').replace(/\t/g, '    ')}

headers = ${JSON.stringify(headers, null, 4).replace(/\n/g, '\n').replace(/\t/g, '    ')}

response = requests.post(url, json=payload, headers=headers)

if response.status_code == 200:
    # SUCCESS
    result = response.json()
    print("Macro execution result:", result)
else:
    # ERROR
    print(f"Error: {response.status_code}")
    print(response.text)`;
    }

    getJavascriptCode = (url, payload, accessKey, secretKey) => {
        let headers = {
            "Content-Type": "application/json"
        };
        
        if (accessKey) {
            headers["accessKey"] = accessKey;
        }
        if (secretKey) {
            headers["secretKey"] = secretKey;
        }

        return `fetch("${url}", {
    method: "POST",
    headers: ${JSON.stringify(headers, null, 4).replace(/\n/g, '\n        ').replace(/\t/g, '    ')},
    body: JSON.stringify(${JSON.stringify(payload, null, 4).replace(/\n/g, '\n        ').replace(/\t/g, '    ')})
})
.then(response => {
    if (response.ok) {
        return response.json();
    }
    throw new Error('Network response was not ok');
})
.then(data => {
    // SUCCESS
    console.log("Macro execution result:", data);
})
.catch(error => {
    // ERROR
    console.error("Error:", error);
});`;
    }

    getRubyCode = (url, payload, accessKey, secretKey) => {
        let headers = {
            "Content-Type": "application/json"
        };
        
        if (accessKey) {
            headers["accessKey"] = accessKey;
        }
        if (secretKey) {
            headers["secretKey"] = secretKey;
        }

        return `require 'net/http'
require 'json'

url = "${url}"
uri = URI.parse(url)

payload = ${JSON.stringify(payload, null, 4).replace(/\n/g, '\n').replace(/\t/g, '    ')}

headers = ${JSON.stringify(headers, null, 4).replace(/\n/g, '\n').replace(/\t/g, '    ')}

http = Net::HTTP.new(uri.host, uri.port)
http.use_ssl = true if uri.scheme == 'https'

request = Net::HTTP::Post.new(uri.request_uri)
request.body = payload.to_json

# Set headers
headers.each do |key, value|
    request[key] = value
end

response = http.request(request)

if response.code == '200'
    # SUCCESS
    result = JSON.parse(response.body)
    puts "Macro execution result: #{result}"
else
    # ERROR
    puts "Error: #{response.code}"
    puts response.body
end`;
    }

    getPHPCode = (url, payload, accessKey, secretKey) => {
        let headers = [
            "Content-type: application/json"
        ];
        
        if (accessKey) {
            headers.push("accessKey: " + accessKey);
        }
        if (secretKey) {
            headers.push("secretKey: " + secretKey);
        }

        return `<?php
$url = "${url}";
$payload = ${JSON.stringify(payload, null, 4).replace(/\n/g, '\n').replace(/\t/g, '    ')};

$data = json_encode($payload);

$curl = curl_init($url);
curl_setopt($curl, CURLOPT_HEADER, false);
curl_setopt($curl, CURLOPT_RETURNTRANSFER, true);
curl_setopt($curl, CURLOPT_HTTPHEADER, array(
${headers.map(h => '    "' + h + '"').join(",\n")}
));
curl_setopt($curl, CURLOPT_POST, true);
curl_setopt($curl, CURLOPT_POSTFIELDS, $data);

$json_response = curl_exec($curl);
$status = curl_getinfo($curl, CURLINFO_HTTP_CODE);

if ($status == 200) {
    // SUCCESS
    $result = json_decode($json_response, true);
    echo "Macro execution result: " . print_r($result, true);
} else {
    // ERROR
    echo "Error: " . $status;
    echo $json_response;
}

curl_close($curl);
?>`;
    }

    render() {
        let url = this.props.getURL.replace("/data/", "/macro/");

        let accessKey = getQueryParamValue("accessKey", url);
        let secretKey = getQueryParamValue("secretKey", url)

        let accessKeyReq = accessKey !== "" ? '\n\t"accessKey":"' + accessKey + '",' : "";
        let secretKeyReq = secretKey !== "" ? '\n\t"secretKey":"' + secretKey + '",' : ""

        let jsonparams = '{}';
        if (this.state.executeType === "macros"){
            jsonparams = '{' +
                accessKeyReq + secretKeyReq +
                '\n\t"macro_name":"GetPremium",' +
                '\n\t"macro_parameters":["Male", 30],' +
                '\n\t"sheet_name":"Rates",' +
                '\n\t"output_cells":["C8", "C9"],' +
                '\n\t"save_file_post_call": true' +
                '\n}'
        } else if (this.state.executeType === "formulas"){
            jsonparams = '{' +
                accessKeyReq + secretKeyReq +
                '\n\t"input_cells":{"A10": 150, "C15": "Male"},' +
                '\n\t"sheet_name":"Rates",' +
                '\n\t"output_cells":["C8", "C9"],' +
                '\n\t"save_file_post_call": true' +
                '\n}'
        }

        if (url.includes("?")){
            url = url.substring(0, url.indexOf("?"))
        }

        const options = [
            {key: 1, text: 'macros', value: 'macros'},
            {key: 2, text: 'formulas', value: 'formulas'}
        ];

        const toolbarSelectedStyle = {color: "#6FBB98", fontSize: "14px"}
        const originalToolbarStyle = {color: "#9696A0", fontSize: "14px"}

        return (
            <div>
                
                <CopyURLSegment
                    url={url}
                    header={<span>API URL
                        <span style={{ backgroundColor: "orange", color: "white", fontSize: "85%", padding: "0 4px 0 4px", fontWeight: "700", marginLeft: "6px"}}>
                            POST
                        </span></span>}
                />
                <br/>
                <CustomAccordion
                    open
                    header={<span>Sample Request</span>}
                    body={<ReactJson src={this.getSamplePayload()} name={null} theme="ocean" displayObjectSize={false} />}
                    accordionStyle={{
                        borderRadius: '4px',
                        border: '1px solid #F0F0F0',
                        backgroundColor: 'white'
                    }}
                    headerDivStyle={{
                        borderRadius: '4px',
                        backgroundColor: 'white',
                        fontSize: '16px',
                        fontWeight: '700',
                        fontFamily: 'Lato',
                        padding: '16px'
                    }}
                />
                <br />
                <CustomAccordion
                    open
                    header={<span>Code Samples</span>}
                    body={<CodeSnippet code={this.getCodeSamples()} height={200} />}
                    accordionStyle={{
                        borderRadius: '4px',
                        border: '1px solid #F0F0F0',
                        backgroundColor: 'white'
                    }}
                    headerDivStyle={{
                        borderRadius: '4px',
                        backgroundColor: 'white',
                        fontSize: '16px',
                        fontWeight: '700',
                        fontFamily: 'Lato',
                        padding: '16px'
                    }}
                />
                
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    fileInformation: state.mainState.fileInformation,
    sheetRead: state.mainState.sheetRead
})

const mapActionsToProps = {
    toggleToast: toggleToast,
    toggleModal: toggleModal
}

export default connect(mapStateToProps, mapActionsToProps)(MacroIndex)